import {useSelector} from 'react-redux'
import {getOverlay} from 'modules/overlay/selectors'

export const useCloseTopOverlays = () => {
  const overlayState = useSelector(getOverlay)

  const closeTopOverlays = () => {
    const overlayCount = overlayState?.length
    if (overlayCount > 0) {
      history.go(-overlayCount)
    }

    return overlayCount
  }

  return closeTopOverlays
}
